import http from './request'

// 获取用户任务列表
export const getWaRecallTasks = (data) => {
  return http({
    url: '/promotion/WaRecallActivityTaskRecord/getTasks',
    method: 'post',
    data
  })
}

// 获取召回的消息信息(用于发送wa）
export const getWaRecallMessageInfo = (data) => {
  return http({
    url: '/promotion/WaRecallActivityTaskRecord/getWaRecallMessageInfo',
    method: 'post',
    data
  })
}

// 获取wa召回活动用户信息
export const getWaRecallUserInfo = (data) => {
  return http({
    url: '/promotion/WaRecallActivityUser/getInfo',
    method: 'post',
    data
  })
}

// 完成视频上传任务
export const completeWaRecallTask = (data) => {
  return http({
    url: '/promotion/WaRecallActivityTaskRecord/completeTask',
    method: 'post',
    data
  })
}

// 领取奖励
export const claimWaRecallReward = (data) => {
  return http({
    url: '/promotion/WaRecallActivityTaskRecord/claimReward',
    method: 'post',
    data
  })
}
